import { ReactElement, ReactNode } from "react";

type RowProps = {
    children?: ReactNode[] | ReactElement;
    gap?: number;
    className?: string;
}

/*
gap-1 gap-2 gap-3 gap-4 gap-5 gap-6
*/

export const Row = ({...props}: RowProps) => {
  return (
    <div className={`flex flex-row flex-wrap ${props.gap ? `gap-${props.gap}`:``} ${props.className ? props.className : ''}`}>
        {props.children}
    </div>
  )
}